
export interface ShowcaseConfig {
  countryCode: string;
  countryName: string;

  // Content Configuration
  content: ContentConfig;

  // UI Configuration (optional)
  ui?: UiConfig;

  showcase: DocumentConfig;
}

export interface DocumentConfig {
  showPassport: boolean;
  showIdCard: boolean;
  showResidencePermit: boolean;
  showEvisa: boolean;
}

export interface ThemeConfig {
  [key: string]: string; // CSS Custom Properties as key-value pairs
}

// Recommended optional tokens (documented for environments):
// --showcase-radius-sm/md/lg/xl
// --showcase-surface-1/2 (rgba)
// --showcase-elevation-1/2 (shadow)
// --showcase-spacing-sm/md/lg (px)
// --showcase-font-family (stack)

export interface ContentConfig {
  servicesSection?: ServicesSectionConfig;
}

export interface HeroSectionConfig {
  headline: string;
  subtitle: string;
  backgroundOverlay?: number; // opacity 0-1
}

export interface AboutSectionConfig {
  title: string;
  description: string;
  highlights: HighlightConfig[];
}

export interface HighlightConfig {
  icon: string;
  title: string;
  description: string;
  image?: string;
}

export interface ServicesSectionConfig {
  title: string;
  subtitle?: string;
  services: ServiceConfig[];
}

export interface ServiceConfig {
  icon: string;
  title: string;
  description: string;
  externalUrl?: string;
  category: ServiceCategory;
  image?: string;
}

export interface CtaSectionConfig {
  title: string;
  subtitle: string;
  backgroundImage?: string;
  backgroundOverlay?: number; // opacity 0-1
  trustIndicators?: TrustIndicatorConfig[];
}

export interface UiConfig {
  // Language switcher visibility and placement
  showLanguageSwitcher?: boolean;
  languageSwitcherPosition?: 'top-right' | 'top-left';

  // Section visibility toggles
  showHeroSection?: boolean;
  showAboutSection?: boolean;
  showServicesSection?: boolean;
  showCtaSection?: boolean;

  // Layout options
  maxContainerWidth?: number; // px
}

export interface TrustIndicatorConfig {
  icon: string;
  text: string;
}

export interface MediaConfig {
  heroImage: string;
  flagIcon: string;
  logoImage?: string;
  mobileMidLogo?: string;   // optional logo shown centered in the topbar on mobile only
  backgroundImage?: string;
  galleryImages: string[];
}

export interface EVisaCtaConfig {
  primaryButtonText: string;
  secondaryButtonText?: string;
  primaryAction: () => void;
  secondaryAction?: () => void;
}

export enum ServiceCategory {
  ACCOMMODATION = 'accommodation',
  ACTIVITIES = 'activities',
  TRANSPORT = 'transport',
  COMMUNICATION = 'communication',
  SERVICES = 'services',
  GENERAL = 'general',
  HEALTH = 'health'
}
